module.exports = __webpack_public_path__ + "static/media/right-icon.a20f761a.svg";